import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ToastrService } from 'ngx-toastr';
import { ApisService } from '../../services/apis.service';

@Component({
  selector: 'app-race-auction-claim',
  templateUrl: './race-auction-claim.component.html',
  styleUrls: ['./race-auction-claim.component.scss']
})
export class RaceAuctionClaimComponent implements OnInit {

  @Input() jockey;
  meta: {
    saving: boolean,
    enableSave: boolean
  };
  userId: number;
  claimTypes: any[];
  sellOptions: any[];
  jockeyRaceClaim: {
    id: number | 'new',
    sellOption: {id: number, label: string},
    value: number,
    claimerName: string
  };

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApisService,
    private notification: ToastrService
  ) { }

  ngOnInit() {
    this.meta = {
      saving: false,
      enableSave: false
    }
    this.jockeyRaceClaim = {
      id: null,
      sellOption: {id: null, label: null},
      value: null,
      claimerName: ''
    }
    this.sellOptions = [
      {id: 1, label: 'No Bid'},
      {id: 2, label: 'Sold'},
      {id: 3, label: 'Bought in'}
    ];
    this.loadClaim();

    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });
  }

  loadClaim() {
    if (this.jockey.claims.length) {
      this.jockeyRaceClaim = Object.assign({}, {
        id: this.jockey.claims[0].id,
        sellOption: this.sellOptions.find(o => o.id === this.jockey.claims[0].typeCode),
        value: this.jockey.claims[0].value,
        claimerName: this.jockey.claims[0].claimerName
      });
    }
  }

  validClaim() {
    if (this.jockeyRaceClaim.sellOption.id && this.jockeyRaceClaim.value > 0 && this.jockeyRaceClaim.claimerName.length > 0) {
      this.meta.enableSave = true;
    } else {
      this.meta.enableSave = false;
    }
    if (this.jockeyRaceClaim.sellOption.id === 1) {
      this.meta.enableSave = true;
    }
  }

  confirm() {
    this.meta.saving = true;
    let payload = {
      animalId: this.jockey.animalId,
      jockeyId: this.jockey.jockeyId,
      yearOfRace: this.jockey.yearOfRace,
      raceId: this.jockey.raceId,
      divisionSequence: this.jockey.divisionSequence,
      type: this.jockeyRaceClaim.sellOption.label,
      typeCode: this.jockeyRaceClaim.sellOption.id,
      value: this.jockeyRaceClaim.value,
      claimerName: this.jockeyRaceClaim.claimerName,
      updatedBy: this.userId
    };
    if (this.jockeyRaceClaim.id) {
      payload['id'] = this.jockeyRaceClaim.id;
    }
    this.apiService.updateRaceClaim(payload)
      .subscribe(
        res => {
          // console.log('[ DEBUG ] Jockey Data Saved:', res);
          this.activeModal.close(res);
          this.notification.success(`${this.jockey.animalName} auction result has been saved.`, 'Auction Result');
        },
        err => {
          console.error('[ DEBUG ] Error updating Race Claim', err);
          this.notification.error(`Could't save the auction result. Check your connection and Try again.`, 'Auction Result');
          this.meta.saving = false;
        }
      );
  }

  delete() {
    this.meta.saving = true;
    this.apiService.deleteRaceClaim(this.jockeyRaceClaim.id)
      .subscribe(
        res => {
          // console.log('[ DEBUG ] Jockey Data Saved:', res);
          this.activeModal.close({removeClaim: this.jockeyRaceClaim.id});
          this.notification.success(`Auction Result for ${this.jockeyRaceClaim.claimerName} has been removed.`, 'Auction Result');
          this.meta.saving = false;
        },
        err => {
          console.error('[ DEBUG ] Error deleting Race Claim', err);
          this.notification.error(`Could't remove the Auction Result. Check your connection and Try again.`, 'Auction Result');
          this.meta.saving = false;
        }
      );
  }

  cancel(action) {
    this.activeModal.dismiss(action);
  }

}
